// Single source of truth for the New Year's Day 2027 event ("A Jazz Affair").
// When the user re-uploads the 4 flyers + 1 video, swap the three URL blocks
// below (hero_image, flyer_images, video_url). Every page that references the
// event imports from this file, so one edit updates the home teaser, the
// experiences hero card, and the hero CTA target.

export const NYE_EVENT = {
    slug: "new-years-jazz-affair",
    title: "A Jazz Affair",
    subtitle: "Queer New Year's Celebration",
    presenter: "Mrs.Black(In)Love",
    venue: "Rose & Rye",
    city: "Atlanta, GA",
    date_label: "Friday · January 1, 2027",
    time_label: "7:00 PM – 1:00 AM",
    ticket_url: "https://www.simpletix.com/e/a-jazz-affair-queer-new-year-s-celebration-tickets-296373",
    section_phone: "380-200-0084",
    price_advance: "$25 advance",
    price_door: "$30 at the door (if tickets remain)",
    tagline: "A Queer Women's Rooftop Jazz Lounge Experience.",
    long_description: [
        "Start 2027 in a room created intentionally for queer women.",
        "On Friday, January 1, 2027, Mrs.Black(In)Love takes over Rose & Rye for an elevated New Year's Day celebration combining the intimacy of a jazz lounge, the energy of a rooftop nightlife experience, and the community of a queer women-only space.",
        "From 7:00 PM until 1:00 AM, settle into an evening of live music, cocktails, conversation, poetry, dancing, and incredible rooftop views.",
        "The evening will feature an all-female live jazz band, a female DJ, and open mic poetry performed against an intimate jazz-lounge atmosphere. Expect sounds ranging from live jazz into R&B, neo-soul and more as the evening transitions from lounge to late-night celebration.",
        "Food and drinks will be available for purchase throughout the event.",
        "Come dressed in YOUR VERY BEST — Roaring '20s Glam · Jazz Vibe · Grown & Sexy.",
    ],
    highlights: [
        "All-female live jazz band",
        "Female DJ · R&B, neo-soul, late-night",
        "Open mic poetry",
        "Rooftop views",
        "Food & drinks available for purchase",
        "Queer women-only space",
    ],
    dress_code: "Roaring '20s Glam · Jazz Vibe · Grown & Sexy.",

    // --- MEDIA SWAP ZONE ------------------------------------------------
    // Replace the three fields below with the uploaded flyer URLs + video.
    // Everything else above is final copy and shouldn't need to change.

    // Primary hero image used on home + experiences page card.
    // Main event flyer: saxophone + balloons + full event details.
    hero_image: "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/ab7a132063c991e5_Black%20and%20Yellow%20Jazz%20Concert%20Instagram%20Post%20-%201.webp",

    // Flyer thumbnails displayed as a quiet strip on the experiences page.
    // The "Women Only" flyer is used as the home hero backdrop instead of
    // appearing in the strip (keeps the strip to the 3 secondary flyers).
    flyer_images: [
        {
            src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/c1475220558b8a49_Black%20and%20Yellow%20Jazz%20Concert%20Instagram%20Post%20-%202.webp",
            label: "What should you wear?",
        },
        {
            src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/5b35b6c3887ccbc4_Black%20and%20Yellow%20Jazz%20Concert%20Instagram%20Post%20-%203.webp",
            label: "Your very best",
        },
        {
            src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/17730a141b68ef07_Black%20and%20Yellow%20Jazz%20Concert%20Instagram%20Post%20-%204.webp",
            label: "Women only",
        },
    ],

    // When set, the home teaser renders a native <video>. When null/empty, it
    // falls back to a clean poster image of the main flyer.
    video_url: "https://customer-assets-lxgj4vgw.emergentagent.net/job_elevated-collective/artifacts/9a531342b5b05cd4_04d2fda7a09043d6bf9ac0a995e61b49.mov",

    // Full-length flyer reel on Instagram. Shown under the autoplay video on
    // both the home teaser and the experiences featured card.
    instagram_reel_url: "https://www.instagram.com/reel/DeKhu5MhKII/?stkn=MWxicm9tY2E3cnl3eA==",

    // -------------------------------------------------------------------
};
